import api from '@pray/shared/utils/api';

import type { SeedRunRefreshResponse } from './types';

const RUNS_URL = '/web/studio/admin/seed-emails/runs';

/**
 * "Sync metrics": reads this run's metrics from its vendors, synchronously, and answers the run as
 * it now stands plus `metrics_sync`, what the attempt did. It never moves the run's status.
 *
 * Allowed on any run that accepted at least one message, `failed` included. A run no vendor
 * measures is refused with `seed_run_metrics_not_applicable`, a run with nothing accepted with
 * `seed_run_not_collectable`, and a SparkPost read inside its 60 s cooldown with
 * `seed_run_metrics_sync_cooldown`. All are stable codes on a 400, and the caller reads them with
 * `readErrorCode`.
 */
export async function postRefreshRun(runId: string) {
  const res = await api.executePostRequest<{ data: SeedRunRefreshResponse }>(`${RUNS_URL}/${runId}/refresh`);
  return res.data.data;
}
